import { NativeDateAdapter } from '@angular/material/core';
import { Injectable } from '@angular/core';

@Injectable()
export class MPDateAdapter extends NativeDateAdapter {
  // Parse the date from input component as it only expect dates in
  // mm-dd-yyyy format
  parse(value: any): Date | null {
    if (typeof value === 'string' && value.indexOf('/') > -1) {
      const str = value.split('/');

      let year: number;
      if (str[2].length === 2) {
        year = parseInt(`20${str[2]}`, 10);
      } else {
        year = parseInt(str[2], 10);
      }
      const month = parseInt(str[1], 10) - 1;
      const day = parseInt(str[0], 10);

      return new Date(year, month, day);
    }
    const timestamp = typeof value === 'number' ? value : Date.parse(value);
    return isNaN(timestamp) ? null : new Date(timestamp);
  }

  getFirstDayOfWeek(): number {
    return 1;
  }
}
